import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ms-complex',
  template: `
    <p>
      ms-complex works!
    </p>
  `,
  styles: []
})
export class MsComplexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
